














































import { Component, Vue, Prop, Ref, Watch } from 'vue-property-decorator';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { RegisteredTag } from '@/models/DTO/registered-tag/registered-tag.model';
import { RegisteredTagActions } from '@/constants/actions.constants';
import RegisteredTagModule, {
  REGISTERED_TAG_MODULE_NAME
} from '@/store/modules/registered-tag.module';
import store from '@/store';
import { getModule } from 'vuex-module-decorators';
import { mapState } from 'vuex';
import { BaseAPIErrorModel } from '@/models/DTO/base-api-error.model';

const registeredTagModule: RegisteredTagModule = getModule(
  RegisteredTagModule,
  store
);

@Component({
  components: {
    ValidationProvider,
    ValidationObserver
  },
  computed: {
    ...mapState(REGISTERED_TAG_MODULE_NAME, [
      'showButtonLoading',
      'errorResponse'
    ])
  }
})
export default class ManageTagFormComponent extends Vue {
  @Prop({
    required: true
  })
  current: RegisteredTag;

  public showButtonLoading: boolean;
  public errorResponse: BaseAPIErrorModel | null;
  public tag = '';

  @Ref()
  public manageTagForm!: HTMLFormElement;

  @Watch('errorResponse', { deep: true })
  private onErrorResponseChanged(value: BaseAPIErrorModel) {
    if (value) {
      const errors = value.getAllErrorMessages();
      return this.$toasted.error(errors.join());
    }
  }

  public onHideEvent() {
    this.tag = '';
    this.manageTagForm.reset();
  }

  public onCancelClick() {
    this.$bvModal.hide('modal-manage-tag');
  }

  public async onManageTagSaveClick(): Promise<void> {
    await registeredTagModule[RegisteredTagActions.updateTagAction]({
      id: this.current.id ?? '',
      code: this.tag,
      customerId: this.current.customerId,
      veterinarianOfficeId: this.current.veterinarianOfficeId
    });

    if (!this.errorResponse) {
      this.$emit('completion-handler', this.tag);
    }
  }
}
